export const TEAM_PLAN_FEATURES = [
  '',
  'Unlimited projects',
  'Guest edit & comments',
  'Members-only projects',
  'Team space with folders',
  'Priority support',
  'Shared symbol library',
]

export const TEAM_AMOUNT = 24
